import { ApplicationPageProps } from '../../Application';
import { ReferralSelection } from '../shared/ReferralSelection';


const LUMEN_REFERRAL_OPTIONS = [
	{ text: 'A colleague within your company', textValue: 'colleague' },
	{ text: 'Your manager', textValue: 'manager' },
	{ text: 'Your Global CSR leader', textValue: 'globalCSR' },
	{ text: 'Your Regional CSR leader', textValue: 'regionalCSR' },
	{ text: 'Email communication from your company', textValue: 'email' },
	{ text: 'Internal meeting or town hall', textValue: 'meeting' },
	{ text: 'LinkedIn', textValue: 'linkedin' },
	{ text: 'Other', textValue: 'other' },
];

export const LumenReferralSelection = (props: ApplicationPageProps) => {

	return (
		<ReferralSelection
			{...props}
			referralOptions={LUMEN_REFERRAL_OPTIONS}
			programTermsText="Yes, I've talked with my manager and have their support to participate."
		/>
	);
};
